// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import '@plesk/ui-library/dist/plesk-ui-library.css';

export * from '@plesk/ui-library';

import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED as reactInternals } from 'react';
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED as reactDomInternals } from 'react-dom';
export const __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = { ...reactInternals, ...reactDomInternals };

export {
    createPortal,
    findDOMNode,
    flushSync,
    hydrate,
    render,
    unmountComponentAtNode,
    // eslint-disable-next-line camelcase
    unstable_batchedUpdates,
} from 'react-dom';
export {
    createRoot,
    hydrateRoot,
} from 'react-dom/client';
export {
    Children,
    Component,
    Fragment,
    PureComponent,
    StrictMode,
    Suspense,
    cloneElement,
    createContext,
    createElement,
    createFactory,
    createRef,
    forwardRef,
    isValidElement,
    lazy,
    memo,
    startTransition,
    useCallback,
    useContext,
    useDebugValue,
    useDeferredValue,
    useEffect,
    useId,
    useImperativeHandle,
    useInsertionEffect,
    useLayoutEffect,
    useMemo,
    useReducer,
    useRef,
    useState,
    useSyncExternalStore,
    useTransition,
} from 'react';
export { jsx, jsxs } from 'react/jsx-runtime';
export { default as classNames } from 'classnames';
export { default as PropTypes } from 'prop-types';
export { default as Measure } from 'react-measure';
